import * as PIXI from 'pixi.js';
import { Howl } from 'howler';
import Config from './Config';
import * as Sounds from './Sounds';

export default class Life extends PIXI.Container {
  constructor(x, y) {
    super();

    this.elapsedTime = 0;
    this.isCollected = false;
    this.sprite = null;
    this.initialX = x;

    this.position.set(x, y);

    this.onResourcesLoaded();
  }

  onResourcesLoaded() {
    this.sprite = new PIXI.Sprite(PIXI.Loader.shared.resources['lifeIcon'].texture);
    this.sprite.anchor.set(0.5, 0.5);

    this.addChild(this.sprite);

    // this.graphics = new PIXI.Graphics();
    // this.graphics.beginFill(0xff0000);
    // this.graphics.drawCircle(0, 0, Config.LIFE_RADIUS);
    // this.graphics.endFill();
    // this.addChild(this.graphics);
  }

  update(dt, [
    background,
    foreground,
    player,
    ground,
    ...treasures
  ]) {
    const playerOnscreenX = Config.PLAYER_ONSCREEN_POSITION * Config.GAME_WIDTH;

    this.elapsedTime = (this.elapsedTime + dt) % Config.TREASURE_FLOAT_PERIOD;

    this.position.x = this.initialX - player.positionX;

    if (this.sprite) {
      this.sprite.position.y = Config.TREASURE_FLOAT_AMPLITUDE * Math.sin((this.elapsedTime * 2 * Math.PI) / Config.TREASURE_FLOAT_PERIOD);
    }

    if (this.isCollected) {
      this.rotation = this.rotation + Config.TREASURE_COLLECTED_ROTATION_SPEED * dt;
      this.alpha = Math.max(0, this.alpha - dt / Config.TREASURE_COLLECTED_FADE_OUT_DURATION);
    } else {
      if (player.isDead) return;

      const dx = playerOnscreenX - this.position.x;
      const dy = player.position.y - this.position.y;
      const distanceSquared = dx * dx + dy * dy;
      const radiiSum = Config.PLAYER_RADIUS + Config.LIFE_RADIUS;
      const isColliding = distanceSquared < (radiiSum * radiiSum);

      if (isColliding) {
        this.isCollected = true;

        Sounds.collect.play();

        player.addLife(1);
      }
    }
  }
}
